import css from './index.less'

export default {
  index: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages'),
  makereport: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages'),
  makeorderdetail: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages'),
  buyreport: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages'),
  buyorderdetail: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages'),
  explain: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages'),
  topay: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages'),
  topaytwo: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages'),
  payresult: resolve => require.ensure([], ()=>{resolve(require('./base.js'))}, 'pages')
}


// WEBPACK FOOTER //
// ./src/pages/personal/index.js